import React, { useEffect, useRef, useState } from "react";
import "./mob.css";
import "./main.css";
import { symbols, details } from "./dataStore";
import Data from "./dataStore";
import $ from "jquery";
import { AiFillCaretUp } from "react-icons/ai";
import { AiFillCaretDown } from "react-icons/ai";
import { TfiImage } from "react-icons/tfi";
import { GiCrossMark } from "react-icons/gi";
import { BiLinkExternal } from "react-icons/bi";
import Animation from "./imgs/animation.gif";
export default function Mob() {
  const [skill, setSkill] = useState([]);
  const [skillCount, setSkillCount] = useState(1);
  const [projSwitch, setprojSwitch] = useState(0);
  const [imageSwitch, setImageSwitch] = useState(false);
  const [imageCount, setImageCount] = useState(0);
  const mobProj = useRef();
  useEffect(() => {
    setSkill(symbols.fe);
  }, []);
  const skillChange = (num) => {
    if (num == 1) {
      if (skill[0][1] != "React.js") {
        $(".skillsContainer").css({
          animation: "rotateSkill 0.5s linear forwards",
        });
        let timer = setTimeout(() => {
          setSkill(symbols.fe);
          $(".skillsContainer").css({
            animation: "none",
          });
          $(`#skillField:nth-child(${skillCount})`).css({
            fontSize: "2.5vmax",
            filter: "drop-shadow(0 0 0px white)",
          });
          $(`#skillField:nth-child(1)`).css({
            fontSize: "3vmax",
            filter: "drop-shadow(0 0 10px white)",
          });
          setSkillCount(1);
          clearTimeout(timer);
        }, 500);
      }
    } else if (num == 2) {
      if (skill[0][1] != "Node.js") {
        $(".skillsContainer").css({
          animation: "rotateSkill 0.5s linear forwards",
        });
        let timer = setTimeout(() => {
          setSkill(symbols.be);
          $(".skillsContainer").css({
            animation: "none",
          });
          $(`#skillField:nth-child(${skillCount})`).css({
            fontSize: "2.5vmax",
            filter: "drop-shadow(0 0 0px white)",
          });
          $(`#skillField:nth-child(3)`).css({
            fontSize: "3vmax",
            filter: "drop-shadow(0 0 10px white)",
          });
          setSkillCount(3);
          clearTimeout(timer);
        }, 500);
      }
    } else if (num == 3) {
      if (skill[0][1] != "") {
        $(".skillsContainer").css({
          animation: "rotateSkill 0.5s linear forwards",
        });
        let timer = setTimeout(() => {
          setSkill(symbols.core);
          $(".skillsContainer").css({
            animation: "none",
          });
          $(`#skillField:nth-child(${skillCount})`).css({
            fontSize: "2.5vmax",
            filter: "drop-shadow(0 0 0px white)",
          });
          $(`#skillField:nth-child(5)`).css({
            fontSize: "3vmax",
            filter: "drop-shadow(0 0 10px white)",
          });
          setSkillCount(5);
          clearTimeout(timer);
        }, 500);
      }
    } else if (skill[0][1] != "Git") {
      $(".skillsContainer").css({
        animation: "rotateSkill 0.5s linear forwards",
      });
      let timer = setTimeout(() => {
        setSkill(symbols.vc);
        $(".skillsContainer").css({
          animation: "none",
        });
        $(`#skillField:nth-child(${skillCount})`).css({
          fontSize: "2.5vmax",
          filter: "drop-shadow(0 0 0px white)",
        });
        $(`#skillField:nth-child(7)`).css({
          fontSize: "3vmax",
          filter: "drop-shadow(0 0 10px white)",
        });
        setSkillCount(7);
        clearTimeout(timer);
      }, 500);
    }
  };

  const goUp = () => {
    mobProj.current.style.transform = `translateY(${projSwitch + 60}vh)`;
    setprojSwitch(projSwitch + 60);
  };
  const goDown = () => {
    mobProj.current.style.transform = `translateY(${projSwitch - 60}vh)`;
    setprojSwitch(projSwitch - 60);
  };

  const imagesSwitch = (index) => {
    setImageSwitch(true);
    setImageCount(index);
  };
  const closeImage = () => {
    setImageSwitch(false);
  };
  return (
    <div className="mobMain" style={{ overflow: "visible" }}>
      <div id="mobWelcomeMain">
        <div id="wellcome" style={{ position: "static" }}>
          <span id="letterW">W</span>
          <span id="letterE">e</span>
          <span id="letterL">l</span>
          <span id="letterL2">l</span>
          <span id="letterC">C</span>
          <span id="letterO">o</span>
          <span id="letterM">m</span>
          <span id="letterE2">e</span>
          <span>!</span>
        </div>
      </div>
      <div id="mobSecondMain">
        <div
          id="mtxt"
          className="mobMtxt"
          style={{ height: "100%", width: "90%" }}
        >
          <h1 id="mName">I'm Pradyumna Savadatti</h1>
          <p id="mPara" style={{ textAlign: "center" }}>
            Hey there! Welcome to my website. <br />
            Here you can get brief details about me, like my technical skills
            and project details.
          </p>
        </div>
        <div id="mobAnimation">
          <img src={Animation} />
        </div>
      </div>
      <div id="mobThirdMain">
        <div id="skillHead">
          Skill<span id="shakingS">s</span>
        </div>
        <div id="skillsRight">
          <div
            id="skillField"
            onClick={() => {
              skillChange(1);
            }}
          >
            FrontEnd
          </div>
          <div id="skillFieldLine"></div>
          <div
            id="skillField"
            onClick={() => {
              skillChange(2);
            }}
          >
            BackEnd
          </div>
          <div id="skillFieldLine"></div>
          <div
            id="skillField"
            onClick={() => {
              skillChange(3);
            }}
          >
            Core
          </div>
          <div id="skillFieldLine"></div>
          <div
            id="skillField"
            onClick={() => {
              skillChange(4);
            }}
          >
            Version Control
          </div>
        </div>
        <div id="skillsLeft">
          {skill.map((i) => {
            return (
              <div className="skillsContainer">
                {i[0]}
                {i[1]}
              </div>
            );
          })}
        </div>
      </div>
      <div id="mobFourthMain">
        <div id="skillHead">
          Project<span id="shakingS">s</span>
        </div>

        <div id="mobArrowUp">
          {projSwitch != 0 && <AiFillCaretUp onClick={goUp} />}
        </div>

        <div id="mobProjMain">
          <div id="mobProjMainSub" ref={mobProj}>
            {Data.map((data, index) => {
              return (
                <>
                  <div id="mobProjTitle">{data[0]}</div>
                  <div id="mobProjContent">
                    <div id="mobProjContentDetails">
                      {details[Data.length - 1 - index].description}
                    </div>
                    <div id="mobProjTechs">
                      {details[Data.length - 1 - index].tech.map((tech) => {
                        return <div id="mobProjTechTitle">{tech}</div>;
                      })}
                    </div>
                    <div id="mobProjectDeploy">
                      {details[Data.length - 1 - index].online && (
                        <div id="ccLink">
                          <div id="ccBtn">
                            <a
                              href={details[Data.length - 1 - index].link}
                              target="_blank"
                              style={{
                                color: "white",
                                textDecoration: "none",
                              }}
                            >
                              <BiLinkExternal id="linkIcon" />
                            </a>
                          </div>
                        </div>
                      )}
                      {!details[Data.length - 1 - index].online && (
                        <div id="ccImages">
                          <div
                            id="ccBtn"
                            onClick={() => {
                              imagesSwitch(index);
                            }}
                          >
                            <TfiImage id="linkIcon" />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>

        <div id="mobArrowDown">
          {projSwitch != (Data.length - 1) * -60 && (
            <AiFillCaretDown onClick={goDown} />
          )}
        </div>
        {imageSwitch && (
          <div id="mobImagesMain">
            <div id="mobImageClose">
              <GiCrossMark onClick={closeImage} />
            </div>
            <div id="mobImages">
              <div id="mobImagesSub">
                {Data[imageCount][1].map((i) => {
                  return <img src={i} id="mobActualImage" draggable="false" />;
                })}
              </div>
            </div>
          </div>
        )}
      </div>
      <div id="mobProjBackAnimation">
        <div id="demo1"></div>
        <div id="demo2"></div>
        <div id="demo3"></div>
        <div id="demo4"></div>
        <div id="demo5"></div>
        <div id="demo6"></div>
        <div id="demo7"></div>
        <div id="demo8"></div>
        <div id="demo9"></div>
        <div id="demo10"></div>
        <div id="dem1"></div>
        <div id="dem2"></div>
        <div id="dem3"></div>
        <div id="dem4"></div>
        <div id="dem5"></div>
        <div id="dem6"></div>
        <div id="dem7"></div>
        <div id="dem8"></div>
        <div id="dem9"></div>
        <div id="dem10"></div>
        <div id="deo1"></div>
        <div id="deo2"></div>
        <div id="deo3"></div>
        <div id="deo4"></div>
        <div id="deo5"></div>
        <div id="deo6"></div>
        <div id="deo7"></div>
        <div id="deo8"></div>
        <div id="deo9"></div>
        <div id="deo10"></div>
      </div>
    </div>
  );
}
